import DataVDecoration from './decoration';
export default DataVDecoration;
